import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class FeatureNeededModule {
}
FeatureNeededModule.ɵfac = function FeatureNeededModule_Factory(t) { return new (t || FeatureNeededModule)(); };
FeatureNeededModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FeatureNeededModule });
FeatureNeededModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
